export default (arr: any[]) => {
  return [...new Set(arr)]
}
